var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 119,
    height: 120,
    viewBox: "0 0 119 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_351_53028",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 119,
    height: 120
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 119,
    height: 119,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_351_53028)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.2293 99.6666C24.7092 99.6666 18.284 97.0635 12.9538 91.8572C7.6236 86.651 4.9585 80.2878 4.9585 72.7676C4.9585 66.3218 6.90051 60.5784 10.7845 55.5374C14.6686 50.4964 19.7509 47.2735 26.0314 45.8687C28.0974 38.2659 32.2293 32.1093 38.4272 27.3989C44.6252 22.6885 51.6495 20.3333 59.5002 20.3333C69.1689 20.3333 77.3708 23.7008 84.1059 30.4359C90.841 37.1709 94.2085 45.3728 94.2085 55.0416C99.9106 55.7027 104.642 58.1612 108.402 62.4171C112.162 66.673 114.042 71.652 114.042 77.3541C114.042 83.552 111.873 88.8202 107.534 93.1588C103.195 97.4973 97.9272 99.6666 91.7293 99.6666H64.4585C61.7314 99.6666 59.3969 98.6956 57.4548 96.7536C55.5128 94.8115 54.5418 92.477 54.5418 89.7499V64.2145L46.6085 71.8999L39.6668 64.9582L59.5002 45.1249L79.3335 64.9582L72.3918 71.8999L64.4585 64.2145V89.7499H91.7293C95.2002 89.7499 98.1338 88.5517 100.53 86.1551C102.927 83.7586 104.125 80.8249 104.125 77.3541C104.125 73.8832 102.927 70.9496 100.53 68.553C98.1338 66.1565 95.2002 64.9582 91.7293 64.9582H84.2918V55.0416C84.2918 48.1826 81.8746 42.3359 77.0403 37.5015C72.2059 32.6671 66.3592 30.2499 59.5002 30.2499C52.6411 30.2499 46.7944 32.6671 41.9601 37.5015C37.1257 42.3359 34.7085 48.1826 34.7085 55.0416H32.2293C27.4363 55.0416 23.3456 56.7357 19.9575 60.1239C16.5693 63.5121 14.8752 67.6027 14.8752 72.3957C14.8752 77.1888 16.5693 81.2794 19.9575 84.6676C23.3456 88.0558 27.4363 89.7499 32.2293 89.7499H44.6252V99.6666H32.2293Z",
    fill: "inherit"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackup);
export default __webpack_public_path__ + "static/media/Backup.a16906b9d84411645680a29404e974df.svg";
export { ForwardRef as ReactComponent };